import { getAffiliateInfo } from '@/apis/affiliate';
import { validateStaff } from '@/apis/staff';
import { PF_NUMBER_LENGTH } from '@/constants';
import { AgentTypeName } from '@/enums';
import { AffiliateResponse, AffiliateState, StaffResponse } from '@/types/Affiliate';
import { ApiResponseWrapper } from '@/types/Wrapper';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: AffiliateState = {
  environmentEntity: '',
  isStaff: false,
  isValid: false,
  isValidStaff: false,
  loading: false,
  clientPfNumber: undefined,
  isMAEM2U: false,
};

export const affiliateSlice = createSlice({
  name: 'affiliate',
  initialState,
  reducers: {
    setAffiliateId: (state, action: PayloadAction<string | undefined>) => {
      state.agentId = action.payload;
    },
    setIsDirectAgent: (state, action: PayloadAction<boolean>) => {
      state.isDirectAgent = action.payload;
    },
    setIsStaff: (state, action: PayloadAction<boolean>) => {
      state.isStaff = action.payload;
      // if (!action.payload) {
      //   state.clientPfNumber = '';
      // }
    },
    setProductEntityId: (state, action: PayloadAction<number | undefined>) => {
      state.productEntityId = action.payload;
    },
    setAgentCode: (state, action: PayloadAction<string | undefined>) => {
      state.agentCode = action.payload;
    },
    setAgentBranchCode: (state, action: PayloadAction<string | undefined>) => {
      state.agentBranchCode = action.payload;
    },
    setLeadGenerator: (state, action: PayloadAction<string | undefined>) => {
      state.leadGenerator = action.payload;
    },
    setBancaBranchCode: (state, action: PayloadAction<string | undefined>) => {
      state.bancaBranchCode = action.payload;
    },
    setType: (state, action: PayloadAction<string | undefined>) => {
      state.type = action.payload;
    },
    setSalePFNumber: (state, action: PayloadAction<string | undefined>) => {
      state.salesPfNumber = action.payload;
    },
    setAffiliateEntity: (state, action: PayloadAction<string>) => {
      state.environmentEntity = action.payload;
    },
    resetAffiliateState: () => {
      return initialState;
    },
    setAgentAIDValue: (state, action) => {
      // Assuming action is a direct string value
      state.agentId = action.payload;
    },
    setClientPfNumber: (state, action: PayloadAction<string | undefined>) => {
      state.clientPfNumber = action.payload;
      if (action.payload === undefined || action.payload.length !== PF_NUMBER_LENGTH) {
        state.isValidStaff = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAffiliateInfo.pending, (state) => {
        state.loading = true;
        state.agentCode = undefined;
      })
      .addCase(getAffiliateInfo.fulfilled, (state, action) => {
        const response: ApiResponseWrapper<AffiliateResponse> = action.payload;
        if (!response.succeeded) {
          state.loading = false;
          state.isValid = false;
          state.agentCode = undefined;
          state.agentId = undefined;
          state.productEntity = undefined;
          state.productEntityId = undefined;
          state.salesPfNumber = undefined;
          state.agentId = '';
          state.salesPfNumber = undefined;
          state.agentBranchCode = undefined;
          state.bancaBranchCode = undefined;
          state.agentCode = undefined;
          state.type = undefined;
          state.agentName = undefined;
          state.isStaff = false;
          state.isDirectAgent = false;
          state.isMAEM2U = false;
        } else {
          state.loading = false;
          state.isValid = true;
          state.agentCode = response.data.agentCode;
          state.productEntity = response.data.productEntity;
          state.productEntityId = response.data.productEntityId;
          state.salesPfNumber = response.data.salesPfNumber;
          state.agentBranchCode = response.data.agentBranchCode;
          state.bancaBranchCode = response.data.bancaBranchCode;
          state.leadGenerator = response.data.leadGenerator;
          state.agentCode = response.data.agentCode;
          state.type = response.data.type;
          state.agentName = response.data.agentName;
          state.isDirectAgent = response.data.isDirectAgent;
          state.isMAEM2U = response.data.isMAEM2U ?? false;
        }
      })
      .addCase(getAffiliateInfo.rejected, (state) => {
        state.loading = false;
        state.isValid = false;
        state.productEntity = undefined;
        state.productEntityId = undefined;
        state.agentCode = undefined;
        state.agentId = undefined;
        state.salesPfNumber = undefined;
        state.agentId = '';
        state.agentBranchCode = undefined;
        state.bancaBranchCode = undefined;
        state.agentCode = undefined;
        state.type = undefined;
        state.agentName = undefined;
        state.isStaff = false;
        state.isDirectAgent = false;
      });

    builder
      .addCase(validateStaff.fulfilled, (state, action) => {
        state.clientPfNumber = action.meta.arg;
        const response: ApiResponseWrapper<StaffResponse> = action.payload;

        if (state.type === AgentTypeName.Banca) {
          if (response.succeeded) {
            state.isValidStaff = response.data.activeIndicator === 'Y';
          } else {
            state.isValidStaff = false;
          }
        }
      })
      .addCase(validateStaff.rejected, (state, action) => {
        state.clientPfNumber = action.meta.arg;
        state.isValidStaff = false;
      });
  },
});

export const {
  resetAffiliateState,
  setAffiliateEntity,
  setAffiliateId,
  setAgentCode,
  setAgentBranchCode,
  setBancaBranchCode,
  setClientPfNumber,
  setIsDirectAgent,
  setIsStaff,
  setLeadGenerator,
  setSalePFNumber,
  setType,
} = affiliateSlice.actions;
export default affiliateSlice.reducer;
